import { ArrowUp, ArrowDown, Minus } from "lucide-react";

export default function StatCard({ icon: Icon, label, value, trend, subtext }) {
  const isUp = trend?.direction === "up";
  const isDown = trend?.direction === "down";

  return (
    <div
      className="flex flex-col gap-3 px-5 py-4 bg-white border rounded-xl border-neutral-100"
      style={{ boxShadow: "0 1px 4px rgba(0,0,0,0.04)" }}
    >
      {/* Label row */}
      <div className="flex items-center justify-between">
        <span className="text-[11px] font-semibold text-neutral-400 uppercase tracking-[0.07em]">
          {label}
        </span>
        <div
          className="flex items-center justify-center rounded-lg w-7 h-7"
          style={{ background: "rgba(0,157,185,0.08)" }}
        >
          <Icon size={14} style={{ color: "#009DB9" }} />
        </div>
      </div>

      {/* Value */}
      <div className="text-[26px] font-bold text-neutral-900 tracking-[-0.5px] leading-none">
        {value}
      </div>

      {/* Trend + subtext */}
      <div className="flex items-center gap-1.5">
        <span
          className={`flex items-center gap-0.5 text-[11px] font-semibold ${
            isUp ? "text-green-600" : isDown ? "text-red-500" : "text-neutral-500"
          }`}
        >
          {isUp && <ArrowUp size={11} />}
          {isDown && <ArrowDown size={11} />}
          {!isUp && !isDown && <Minus size={11} />}
          {trend?.value}
        </span>
        <span className="text-[11px] text-neutral-400">{subtext}</span>
      </div>
    </div>
  );
}